import { createFileRoute } from "@tanstack/react-router";

import CampaignEditorPage from "@/app/CampaignEditorPage";

export const Route = createFileRoute("/campaign/$shortId/map-note/$mapNoteId")({
  component: CampaignEditorPage,
});
